import { useTheme } from '@mui/material/styles';
import { Doughnut } from 'react-chartjs-2';

const Ellipsis = () => {
  const theme = useTheme();

  return (
    <Doughnut
      data={{
        labels: ['one'],
        datasets: [
          {
            data: [1],
            backgroundColor: theme.palette.mode === 'dark' ? 'black' : theme.palette.grey[300],
            borderWidth: 0
          }
        ]
      }}
      options={{
        cutout: '63%',
        layout: { padding: 5 },
        animation: {
          duration: 0
        },
        plugins: {
          tooltip: {
            backgroundColor: theme.palette.background.default,
            titleColor: theme.palette.text.primary,
            bodyColor: theme.palette.text.primary,
            displayColors: false
          },
          legend: { display: false }
        }
      }}
    />
  );
};

export default Ellipsis;
